import { render, staticRenderFns } from "./PreProjectButtons.vue?vue&type=template&id=db08c5da&"
import script from "./PreProjectButtons.vue?vue&type=script&lang=js&"
export * from "./PreProjectButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports